var render, staticRenderFns
import script from "./NavItems.vue?vue&type=script&lang=tsx&"
export * from "./NavItems.vue?vue&type=script&lang=tsx&"
import style0 from "./NavItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports